<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible.sync="visible"
      direction="rtl"
      :size="1015"
      show-close
      :before-close="() => $refs.editForm.cancel()"
      append-to-body
      @close="close()"
    >
      <div class="drawer-main">
        <edit-form
          ref="editForm"
          :disabled="disabled"
          :platformCode="platformCode"
          :status.sync="status"
          @close="close()"
          @reload="$emit('reload')"
        />
      </div>
      <div class="drawer-footer">
        <el-button
          v-if="!disabled && isNewInfo"
          type="warning"
          size="small"
          @click="$refs.editForm.save('submit')"
        >
          {{ $l('btn_label_save_submit') || '保存并提交审核' }}
        </el-button>
        <el-button
          v-if="!disabled && isReviewInfo"
          type="primary"
          size="small"
          @click="$refs.editForm.save('save')"
        >
          {{ $l('btn_save') || '保存' }}
        </el-button>
        <el-button size="small" @click="close()">
          {{ $l('btn_cancel') || '取消' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-base-evgSalesPlatform-detail',
  components: {
    EditForm,
  },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    title: { type: String, default: '' },
    platformCode: { type: String, default: '' },
    pageType: { type: String, default: '' },
  },
  data() {
    return { status: '' }
  },
  computed: {
    isNewInfo() {
      return this.pageType === 'add' || this.status == 'C'
    },
    isReviewInfo() {
      return this.pageType === 'add' || this.status == 'C' || this.status == 'Y'
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #72767b;
  display: flex;
  margin-bottom: 12px;
  padding: 20px 20px 0;
}
</style>
